import { useCallback } from 'react'

type AddressExemptionFieldName =
  | 'isAddressExempt'
  | 'address.streetAddress1'
  | 'address.streetAddress2'
  | 'address.pobox'
  | 'address.city'

interface UseUpdateAddressExemptionOptions {
  setValue: (name: AddressExemptionFieldName, value: boolean | string) => void
}

export const useUpdateAddressExemption = ({ setValue }: UseUpdateAddressExemptionOptions) => {
  const updateAddressExemption = useCallback(
    (isAddressExempt: boolean) => {
      setValue('isAddressExempt', isAddressExempt)

      if (isAddressExempt) {
        setValue('address.streetAddress1', '')
        setValue('address.streetAddress2', '')
        setValue('address.pobox', '')
        setValue('address.city', '')
      }
    },
    [setValue],
  )

  return { updateAddressExemption }
}
